
import { defineComponent } from 'vue';
import { useList } from '@/hooks/use-list/index';
import { getUserList } from '@/api/system-config/index';
import { IGetUserListRes, IGetUserListReq } from '@/api/system-config/type.d';
import { ENABLED_LIST } from '@/constant';
import usePermissionConfig from './use-permission-config';

export default defineComponent({
  name: 'UserqueryManage',
  setup() {
    const permissionConfig = usePermissionConfig();
    const {
      params,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
    } = useList<IGetUserListRes, IGetUserListReq>({
      request: {
        api: getUserList,
        params: {
          keyword: '',
        },
      },
      response: {
        tableDataKey: 'data',
      },
    });
    handleSearch();
    return {
      params,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      ENABLED_LIST,
      permissionConfig,
    };
  },
});
